export enum MessageDeliveryStatus {
    sent= 'Sent',
    error = 'Error'
}